// Walkthrough registry.
//
// Maps (simulator kind, walkthrough id) → trainee-facing title + step
// list. Driven by the Equipment Lab's ?walkthrough=<id> query param so
// the same walkthrough author once, two surfaces consume: the inline
// `<GuidedWalkthrough>` drill in module slides, and the Lab single-sim
// view's docked coach panel.
//
// Walkthrough ids are stable per equipment kind (e.g. "panel-
// orientation" works for any controller), so the URL form
// `/lab/<kind>?walkthrough=<id>` resolves to a single entry.

import type { SimulatorKind } from "../..";
import type { WalkthroughStep } from "../../../help/help-types";
import { CROSSOVER_SOLO_PANEL_ORIENTATION } from "./crossover-solo-panel-orientation";
import { PTZ_AW_RP50_PANEL_ORIENTATION } from "./ptz-aw-rp50-panel-orientation";

export interface WalkthroughEntry {
  id: string;
  kind: SimulatorKind;
  title: string;
  steps: WalkthroughStep[];
}

export const WALKTHROUGHS: readonly WalkthroughEntry[] = [
  {
    id: "panel-orientation",
    kind: "ptz-aw-rp50",
    title: "Walk the PTZ Controller",
    steps: PTZ_AW_RP50_PANEL_ORIENTATION,
  },
  {
    id: "panel-orientation",
    kind: "crossover-solo",
    title: "Walk the Crossover Solo",
    steps: CROSSOVER_SOLO_PANEL_ORIENTATION,
  },
] as const;

export function findWalkthrough(
  kind: SimulatorKind,
  id: string,
): WalkthroughEntry | undefined {
  return WALKTHROUGHS.find((w) => w.kind === kind && w.id === id);
}

export function walkthroughsForKind(
  kind: SimulatorKind,
): readonly WalkthroughEntry[] {
  return WALKTHROUGHS.filter((w) => w.kind === kind);
}
